import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import TimerIcon from "@mui/icons-material/Timer";
import { DashboardApi } from "../../../api/DashboardApi";
import KPICard from "./KPICard";

const KPI_CONFIG = [
    {
        key: "totalParticipants",
        label: "總參與人數",
        icon: <PeopleAltIcon fontSize="inherit" />,
        iconBgColor: "#7B52AB",
    },
    {
        key: "todayNewParticipants",
        label: "今天新參與人數",
        icon: <PersonAddIcon fontSize="inherit" />,
        iconBgColor: "#E6813D",
    },
    {
        key: "totalHours",
        label: "總參與時數(分鐘)",
        icon: <AccessTimeIcon fontSize="inherit" />,
        iconBgColor: "#2196F3",
    },
    {
        key: "todayNewHours",
        label: "今天新參與時數(分鐘)",
        icon: <TimerIcon fontSize="inherit" />,
        iconBgColor: "#E05C5C",
    },
];

function getDataFromKey(data, key) {
    // totalParticipants:       data.all_time.total_play_count
    // todayNewParticipants     data.one_day.total_play_count
    // totalHours               data.all_time.total_play_seconds / 3600
    // todayNewHours            data.one_day.total_play_seconds / 3600  
    
    switch (key) {
        case "totalParticipants":
            return data?.all_time?.total_play_count ?? "—";
        case "todayNewParticipants":
            return data?.one_day?.total_play_count ?? "—";
        case "totalHours":
            return data?.all_time ? (data.all_time.total_play_second / 3600).toFixed(1) : "—";
        case "todayNewHours":
            return data?.one_day ? (data.one_day.total_play_second / 3600).toFixed(1) : "—";
        default:
            return "—";
    }
}

export default function DataKPIPanel() {
    const [data, setData] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const result = await DashboardApi.getDashboardData();
                console.debug("Dashboard data: ", result);
                setData(result);
            } catch (err) {
                console.error("Failed to fetch dashboard data", err);
            }
        };
        fetchData();
    }, []);

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "row",
                gap: 2,
                backgroundColor: "#161722",
                p: 2,
                flexWrap: "wrap",
            }}
        >
            {KPI_CONFIG.map(({ key, label, icon, iconBgColor }) => (
                <KPICard
                    key={key}
                    label={label}
                    value={getDataFromKey(data, key)}
                    icon={icon}
                    iconBgColor={iconBgColor}
                />
            ))}
        </Box>
    );
}